<div class="xwai-viz">
  <div class="viz-card">
    <div class="viz-head">
      <span [title]="job()?.job_name"><b>{{ job().job_name }}</b></span>
      <span class="viz-badge" style="text-transform: uppercase; color: white">
        <b>Shot</b>
        <nz-select [(ngModel)]="shotId" nzSize="small" nzVariant="borderless" nzShowSearch
          [nzDropdownMatchSelectWidth]="false" style="width: 90px; color: white; text-align: right;">
          <!-- TODO: populate from an "available shots" resource; for now the current shot only. -->
          <nz-option [nzValue]="shotId()" [nzLabel]="shotId()"></nz-option>
        </nz-select>
      </span>
    </div>

    <!-- Panel selector — tabs depend on the data type (see shot-panels.ts). -->
    <div class="viz-tabs">
      <nz-radio-group [(ngModel)]="selectedPanelKey" nzButtonStyle="solid" nzSize="small">
        @for (panel of panels(); track panel.key) {
        <label nz-radio-button [nzValue]="panel.key">{{ panel.label }}</label>
        }
      </nz-radio-group>
    </div>

    <div class="viz-canvas">
      @if (shotResource.isLoading()) {
      <div class="viz-placeholder">
        <span nz-icon nzType="loading" nzTheme="outline" class="viz-placeholder-icon"></span>
        <span class="viz-placeholder-text">Fetching shot image…</span>
      </div>
      } @else if (shotResource.error()) {
      <div class="viz-placeholder viz-error">
        <span nz-icon nzType="warning" nzTheme="outline" class="viz-placeholder-icon"></span>
        <span class="viz-placeholder-text">Failed to fetch shot image</span>
        <pre class="viz-raw">{{ shotResource.error() }}</pre>
      </div>
      } @else if (shotResource.value(); as shotImage) {
      <img class="shot-image" [src]="shotImage" [alt]="job().job_name + ' shot ' + shotId()" />
      } @else {
      <div class="viz-placeholder">
        <span nz-icon nzType="picture" nzTheme="outline" class="viz-placeholder-icon"></span>
        <span class="viz-placeholder-text">Shot preview not yet loaded</span>
      </div>
      }
      <button
        nz-button
        nzType="primary"
        [nzGhost]="true"
        (click)="add_image_to_flipper()"
        class="add-image-to-flipper-button"
        nzSize="small"
        nz-tooltip
        nzTooltipTitle="Add to image flipper"
        >
        <span nz-icon nzType="select" nzTheme="outline"></span>
      </button>
    </div>

    <div class="viz-meta">
      <div class="viz-pill"><b>Data type</b> {{ dataType() }}</div>

      <!-- Iteration re-fetches immediately. -->
      <div class="viz-pill" style="flex-grow: 1; min-width: 160px;">
        <b>Iteration</b>
        <div style="flex-grow: 1;">
          <nz-slider [(ngModel)]="shotIteration" [nzMin]="0"></nz-slider>
        </div>
      </div>
    </div>

    <!-- Deferred controls: edit freely, then Apply to re-fetch once. -->
    <div class="viz-deferred">
      <div class="viz-pill"><b>Start trace</b>
        <nz-input-number nzVariant="borderless" [(ngModel)]="startTraceDraft" [nzMin]="0" [nzStep]="1" nzSize="small"
          style="width: 80px;"></nz-input-number>
      </div>
      <div class="viz-pill"><b>End trace</b>
        <nz-input-number nzVariant="borderless" [(ngModel)]="endTraceDraft" [nzMin]="0" [nzStep]="1" nzSize="small"
          style="width: 80px;"></nz-input-number>
      </div>
      <div class="viz-pill"><b>Scaling</b>
        <nz-input-number nzVariant="borderless" [(ngModel)]="scalingDraft" [nzStep]="0.1" nzSize="small"
          nzPlaceHolder="auto" style="width: 80px;"></nz-input-number>
      </div>
      <button nz-button nzType="primary" nzSize="small" [disabled]="!pendingChanges()" (click)="applyChanges()">
        Apply
      </button>
    </div>
  </div>
</div>
